import BaseModel from '../BaseModel';

export default class Avatar extends BaseModel {
  static entity = 'avatars';

  static primaryKey = 'id';

  static fields() {
    return {
      active: this.attr(null),
      actor_id: this.string(null).nullable(),
      driver_id: this.string(null).nullable(),
      gender: this.string(null).nullable(),
      image_url: this.string(null).nullable(),
      model_url: this.string(null).nullable(),
      presenter_id: this.string(null).nullable(),
      preview_url: this.string(null).nullable(),
      thumbnail_url: this.string(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      getAvatars() {
        return this.get('ai_interview/avatars');
      },
    },
  }
}
